import Axios from 'axios';
import { baseUrl } from '../config/serviceConfig';

const PostHeader = (path, data) => {
    return Axios({
        method: 'POST',
        url: baseUrl + path,
        data: data,
        headers: {
            'Content-Type': 'application/json',
            'x-nextoken': 'AuthServer2020'
        }
    })
}

export default PostHeader;